<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <div class="topbar m-b-25 d-flex flex-j-between">
        <div class="searchBox">
          <el-input placeholder="稿件标题" v-model="f_title" class="input-with-select">
              <el-button slot="append" icon="el-icon-search" @click="loadData">搜索</el-button>
            </el-input>
        </div>
      </div>

      <el-row>
        <el-col :span="24">
          <el-table ref="tableData" :data="tableData" stripe @select-all="selAll" @selection-change="selChange"  style="width: 100%">
            <el-table-column type="index" label="序号" width="60" align="center"> </el-table-column>
            <el-table-column prop="sn" label="稿件编号" width="100">
              <template slot-scope="scope">
                <span class="sn">{{ scope.row.sn }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="稿件标题" min-width="200">
              <template slot-scope="scope">
                <h3>{{ scope.row.title }}</h3>
              </template>
            </el-table-column>

            <el-table-column prop="subjectName" :label="subName" width="90"></el-table-column>
            <el-table-column prop="authorName" label="作者" width="80"></el-table-column>

            <el-table-column prop="createTime" label="投稿时间" width="140">
              <template slot-scope="scope">
                {{ scope.row.createTime | datefmt2("YYYY-MM-DD HH:mm") }}
              </template>
            </el-table-column>

            <el-table-column prop="letterNoticePage" label="版面数" width="80" align="center"></el-table-column>
            <el-table-column prop="issueCost" label="应收版面费" width="90">
              <template slot-scope="scope"> ￥{{ scope.row.issueCost }} </template>
            </el-table-column>
            <el-table-column prop="letterNoticeTime" label="拟发表时间" width="90" align="center"></el-table-column>

          </el-table>
        </el-col>
      </el-row>

      <div style="margin: 20px 0 0 -5px">
        <el-pagination background layout="sizes,prev, pager, next" :total="total" :page-size="pageSize" :page-sizes="[10, 20, 30, 50]" :current-page="curPage" @current-change="pageChange" @size-change="pageSizeChange"> </el-pagination>
      </div>
    </div>



  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import editorApi from "@/api/editor"

export default {
  components: { PageHeader },
  data() {
    return {
      subName:process.env.VUE_APP_PLATFORM=='dx'?'栏目':'科目',
      headLinks: [{ path: "", title: "已登记版面费稿件" }],
      subjects: [],
      f_subjectId: -1,
      f_title: "",

      curPage: 1,
      pageSize: 10,
      tableData: [],
      selData: [],
      total: 0,

      curArticleId: 0,
      amounts: [],
      articleIds: [],
    }
  },

  mounted() {
    this.loadData()
  },

  methods: {
    pageChange(curPage) {
      this.curPage = curPage
      this.loadData()
    },

    pageSizeChange(val) {
      this.pageSize = val
      this.curPage = 1
      this.loadData()
    },


    loadData() {
      this.tableData = []
      editorApi.getChargeList(this.f_subjectId, this.f_title, 2, "id", "desc", this.curPage, this.pageSize).then((res) => {
        this.tableData = res.rows
        this.total = res.total
      })
    },

    selAll() {
      this.flag = this.$refs.tableData.selection.length > 0
    },
    selChange() {
      this.flag = this.$refs.tableData.selection.length > 0
    },
  },
}
</script>


<style scoped>
.dengJi {
  border: 1px solid #ccc;
  margin-bottom: 25px;
}
.searchBox::after {
  content: "";
  display: block;
  clear: both;
}

.el-table /deep/ th.col-bmf {
  background-color: #409eff !important;
}
.el-table /deep/ th.col-bmf > .cell {
  color: #fff;
}

.el-table--striped /deep/ td.col-bmf {
  background-color: #409eff !important;
}

.panelDj {
  width: calc(100vw - 200px);
  height: 400px;
  border: 1px solid #eee;
  background-color: #fff;
  padding: 15px;
  position: absolute;
  z-index: 800;
  bottom: 0;
}
</style>